import { ResponseModalComponent } from './../../components/response-modal/response-modal.component';
import { Component, OnInit } from '@angular/core';
import { UsersService } from "../../services/admin/users.service";
import { User } from '../../models/user';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormRegisterComponent } from './form-register/form-register.component';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder, EmailValidator } from '@angular/forms';
import { FilterUserDialogComponent } from '../../components/filter-user-dialog/filter-user-dialog.component';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { newUser } from '../../models/newUser';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  selected: any;
  rows = [];
  rows_sociedades = [];
  editEnabled: boolean = false;
  closeResult: string;
  centros_costo = [];
  verDetalle = false;
  busy: boolean = false;
  busyInfo: boolean = false;
  busyListado: boolean = false;
  public registrationForm: FormGroup;
  tituloModal = '';
  mensajeModal = '';

  permisos = [
    { id: 1, enabled: false, description: "Facturas con orden de compra" },
    { id: 2, enabled: false, description: "Facturas sin orden de compra" },
    { id: 3, enabled: false, description: "Revisión de facturas" },
    { id: 4, enabled: false, description: "Complementos" },
    { id: 5, enabled: false, description: "Ver facturas" },
    { id: 6, enabled: false, description: "Estado de cuenta" },
    { id: 7, enabled: false, description: "Administración" },
    // { id: 8, enabled: false, description: "Manuales" },
    // { id: 9, enabled: false, description: "Almacenista" },
    // { id: 10, enabled: false, description: "Aut. Entrada de servicios" },
    // { id: 11, enabled: false, description: "Recepción de mercancias" },
  ];

  //USER dATA FOR CACHE

  passwordEdt = "";
  emailEdt = "";
  nombreEdt: "";
  rfcEdt: "";
  sociedadEdt: "";
  usernameEdt: "";
  direccionEdt: "";
  telefonoEdt: "";

  sociedad = "";
  orgVnts = "";
  ofVnts = "";
  errorSociedad = "";
  errorOrgVnts = "";
  errorOfiVnts = "";

  tituloCambiarEstado;
  estasSeguro;
  elUsuario;
  estadoActivar;
  estadoInactivar;
  tituloEliminarUsuario;
  mensajeEliminarUsuario;
  eliminarLabel;
  eliminarPregunta;
  permisoEdt;
  permiso;
  todosSociedad: boolean = false;
  todosOrgVnts: boolean = false;
  todosOfVnts: boolean = false;

  roles = [
    { id: 2, nombre: 'Cliente' },
    { id: 3, nombre: 'Usuario interno' }
  ]
  countries = ['MX', 'USA'];
  toastErrorBorrarRegistro;
  usuarioActivado;
  usuarioDesActivado;

  constructor(
    private translate: TranslateService,
    private userService: UsersService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private formBuilder: FormBuilder
  ) {
    this.translate.get('texto.ActivarSuccess').subscribe(
      text => {
        this.usuarioActivado = text;
      });
    this.translate.get('texto.desActivarSuccess').subscribe(
      text => {
        this.usuarioDesActivado = text;
      });
    this.translate.get('texto.toastErrorBorrarRegistro').subscribe(
      text => {
        this.toastErrorBorrarRegistro = text;
      });
    this.translate.get('texto.cambiarEstado').subscribe(
      text => {
        this.tituloCambiarEstado = text;
      });
    this.translate.get('texto.estasSeguro').subscribe(
      text => {
        this.estasSeguro = text;
      });
    this.translate.get('texto.elUsuario').subscribe(
      text => {
        this.elUsuario = text;
      });
    this.translate.get('texto.activar').subscribe(
      text => {
        this.estadoActivar = text;
      });
    this.translate.get('texto.inactivar').subscribe(
      text => {
        this.estadoInactivar = text;
      });
    this.translate.get('texto.eliminarUsuarioTitulo').subscribe(
      text => {
        this.tituloEliminarUsuario = text;
      });
    this.translate.get('texto.eliminarUsuarioMensaje').subscribe(
      text => {
        this.mensajeEliminarUsuario = text;
      });
    this.translate.get('texto.eliminarLabel').subscribe(
      text => {
        this.eliminarLabel = text;
      });
    this.translate.get('texto.eliminarPregunta').subscribe(
      text => {
        this.eliminarPregunta = text;
      });

   

  }

  ngOnInit() {
    this.sociedad = "";
    this.orgVnts = "";
    this.ofVnts = "";
    this.errorSociedad = "";
    this.errorOrgVnts = "";
    this.errorOfiVnts = "";

    this.noBack();
    this.loadUserList(3, '', '');
    this.rows = [];
    //this.loadSociedades();
    this.editEnabled = false;
    this.registrationForm = this.formBuilder.group({
      usuario: ['', Validators.compose([ Validators.maxLength(20), Validators.required, Validators.pattern( "^[A-Za-z0-9]*$" )])],
      nombre: ['', Validators.minLength(1)],
      rfc: ['', Validators.minLength(1)],
      pais: ['', Validators.minLength(1)],
      password: ['', Validators.minLength(1)],
      //  permiso: ['', Validators.minLength(1)],
      emailEdt: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.minLength(1)])],
      direccion: [''],
      telefono: [''],
      permiso: [''],
      org: [''],
      soc: [''],
      ofi: ['']
    });
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  private loadUserList(tipo: number, criterio: any, estatus) {
    this.busy = true;
    this.userService.getUsers(tipo, criterio, estatus).subscribe(
      data => {
        if (data.mensaje) {
          this.toasterService.pop('error', data.mensaje);
        } else {
          this.pupulateTable(data);
        }
        this.busy = false;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } else {
          console.log(err);
        }
      },
    );
  }

  reload() {
    this.busyListado = true;
    this.verDetalle = false;
    this.editEnabled = false;
    this.userService.getUsers(3, '', '').subscribe(
      data => {
        if (data.mensaje) {
          this.toasterService.pop('error', data.mensaje);
        } else {
        this.pupulateTable(data);
        }
        this.busyListado = false;
      },
      err => {
        this.busyListado = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          console.log(err);
        }
      },
    );

  }

  loadUserPermisions(userId: number) {
    this.userService.getUsersPermissions(userId).subscribe(

      data => {
        console.log(data);
        // this.us = data.sapCosto;
        this.setPermisos(data.permisos);
      }
      ,
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } else {
          console.log(err);
        }
      },
    );
  }


  private loadSociedades() {
    this.userService.getSociedades().subscribe(
      data => this.rows_sociedades = data.sapSociedad
      ,
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } else {
          console.log(err);
        }
      },
    );
  }


  private pupulateTable(data) {
    // console.log(data);
    // if (data.mensaje == 'No se encontraron usuarios') {
    //   this.rows = [];
    // } else {
    //   this.rows = data;
    // }
    // console.log(this.rows);
    this.rows = data;
  }

  setDataSelect(user){
    this.selected = user;
    // console.log(this.selected.rol);
    this.editEnabled = false;
    this.passwordEdt = this.selected.password;
    this.emailEdt = this.selected.email;
    this.direccionEdt = this.selected.direccion;
    this.telefonoEdt = this.selected.telefono;
    this.permisoEdt = this.selected.permiso;
    //this.loadUserPermisions(this.selected.id);
    this.verDetalle = true;
    
    if(this.selected && this.selected.todosSoc == '1') {
      this.todosSociedad = true;
    } else {
      this.todosSociedad = false;
    }
     
    if(this.selected && this.selected.todosOrg == '1') {
      this.todosOrgVnts = true;
    } else {
      this.todosOrgVnts = false;
    }

    if(this.selected && this.selected.todosOfi == '1') {
      this.todosOfVnts = true;
    } else {
      this.todosOfVnts = false;
    }
  }
  onSelect(event, user) {
    // console.log(user);
    
      this.busy = true;
      this.userService.getUserById(user.userId,3, '', 'estatus').subscribe(
        data => {
          // console.log(data);
          this.setDataSelect(data)
          this.busy = false;
        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout() ;
          } else {
            console.log(err);
          }
        },
      );
    
    
  }

  onActivate(event) {
    // console.log('Activate Event', event);
  }


  updateUser() {

  }

  getSociedadesUser(){
    let usuario = this.selected.userId;
    this.selected.sociedades = [];
    this.userService.obtenerSociedad(usuario).subscribe(
      data => {
        // console.log(data.body);
        this.selected.sociedades = data.body;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } else {
          console.log(err);
        }
      },
    );
  }

  getOrgVntsUser(){
    let usuario = this.selected.userId;
    this.selected.orgVentas = [];
    this.userService.obtenerOrgVnts(usuario).subscribe(
      data => {
        // console.log(data.body);
        this.selected.orgVentas = data.body;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } else {
          console.log(err);
        }
      },
    );
  }

  getOfiVntsUser(){
    let usuario = this.selected.userId;
    this.selected.ofiVentas = [];
    this.userService.obtenerOfiVnts(usuario).subscribe(
      data => {
        // console.log(data.body);
        this.selected.ofiVentas = data.body;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } else {
          console.log(err);
        }
      },
    );
  }

  

  deleteUser(id) {
    console.log(id);
    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloEliminarUsuario;
    modalRef.componentInstance.mensaje1 = this.mensajeEliminarUsuario;

    modalRef.result.then((result) => {
      // console.log(result);

      if (result === 'aceptar') {
        this.busy = true;
        this.userService.borrarUser(id).subscribe(
          data => {
            // console.log(data);
            if (data.mensaje == 'Usuario eliminado') {
              this.busy = false;
              this.ngOnInit();
              this.verDetalle = false;
              this.toasterService.pop('success', data.mensaje);
            } else {
              this.busy = false;
              this.toasterService.pop('error', this.toastErrorBorrarRegistro);
            }

          },
          err => {
            this.busy = false;
            this.toasterService.pop('error', this.toastErrorBorrarRegistro);
            if (err.status === 401) {
              this.storageService.openLogout();
            } else {
              console.log(err);
            }
          },
        );

      }
    });

  }

  private editData() {
    if (this.editEnabled) {
      this.editEnabled = false;
    } else {
      this.editEnabled = true;
    }

  }

  open(content) {

    const modalRef = this.modalService.open(FormRegisterComponent, { backdrop: 'static', keyboard: false, size: 'lg' });
    modalRef.result.then((result) => {
      // console.log(result);
      if (result == 'success') {
        this.ngOnInit();
      }
    }).catch((error) => {
      console.log(error);
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilterDialof() {
    const modalRef = this.modalService.open(FilterUserDialogComponent, { size: 'sm', centered: true });
    modalRef.result.then((result) => {
      // console.log(result);
      if (result !== 'close') {
        this.performSearch(result); 
      }


    }).catch((error) => {
      console.log(error);
    });
    modalRef.componentInstance.name = 'World';
    modalRef.componentInstance.option = 'World';
  }


  performSearch(data: any) {

    //perform searh by filter and set the filter for refresh
    let estatus = parseInt(data.estatus);
    let tipo = parseInt(data.tipo);
    let valor = data.criterio;
    // console.log(tipo);
    // console.log(valor);
    // console.log(estatus);
    if (tipo == 4) tipo = 3;
    this.loadUserList(tipo, valor, estatus);
  }



  setPermisos(userPermissions: any) {

    this.permisos = [
      { id: 1, enabled: false, description: "Facturas con orden de compra" },
      { id: 2, enabled: false, description: "Facturas sin orden de compra" },
      { id: 3, enabled: false, description: "Revisión de facturas" },
      { id: 4, enabled: false, description: "Complementos" },
      { id: 5, enabled: false, description: "Ver facturas" },
      { id: 6, enabled: false, description: "Estado de cuenta" },
      { id: 7, enabled: false, description: "Administración" },
      // { id: 8, enabled: false, description: "Manuales" },
      // { id: 9, enabled: false, description: "Almacenista" },
      // { id: 10, enabled: false, description: "Aut. Entrada de servicios" },
      // { id: 11, enabled: false, description: "Recepción de mercancias" },
    ];


    for (let p of userPermissions) {
      // console.log(p);
      this.permisos.find(x => x.id === p.permiso_id).enabled = true;
    }



  }


  saveUserInfo() {
    this.busy = true;
    // console.log(this.selected);

    let soc, org, ofi;
    if(this.todosSociedad) {
      soc = '1';
    } else {
      soc = '0';
    }
    if(this.todosOrgVnts) {
      org = '1';
    } else {
      org = '0';
    }
    if(this.todosOfVnts) {
      ofi = '1';
    } else {
      ofi = '0';
    }

    let userData: newUser = this.selected;
    userData.todosSoc = soc;
    userData.todosOrg = org;
    userData.todosOfi = ofi;

    // console.log(userData);
    // console.log(this.permiso);
    let validForm = true
    if (validForm) {

      this.userService.updateUser(userData).subscribe(
        data => {
          // console.log(data);
          if (data !== null) {
            this.busy = false;
            this.toasterService.pop('success', data.body.mensaje);
          }
          this.ngOnInit();
          //  console.log(resp.headers.get('Cookie'));
        },
        err => {
          this.busy = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } else {
            console.log(err);
          }
        },
      );
    } else {
      this.busy = false;
    }
  }

  cambiarEstatus(selected) {
    // console.log(selected);
    let estatus = selected.activo;
    let idU = selected.userId;
    let estado: string = "";
    if (estatus) {
      estatus = false;
      estado = 'Inactivar';
    } else {
      estatus = true;
      estado = 'Activar';
    }

    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloCambiarEstado;
    modalRef.componentInstance.mensaje1 = this.estasSeguro;
    modalRef.componentInstance.mensaje2 = this.elUsuario;
    modalRef.componentInstance.mensaje3 = estado;

    modalRef.result.then((result) => {
      // console.log(result);
      if (result === 'aceptar') {
        this.userService.estatusUsuario(idU, estatus).subscribe(
          data => {
            if (estado == 'Inactivar' ) {
              this.toasterService.pop('success', this.usuarioDesActivado);
            }
            if (estado == 'Activar' ) {
              this.toasterService.pop('success', this.usuarioActivado);
            }
            
            // console.log(data);
            this.loadUserList(3, '', '');
            this.verDetalle = false;
          }
          ,
          err => {
            if (err.status === 401) {
              this.storageService.openLogout() ;
            } else {
              console.log(err);
            }
          },
        );
      }
    });
  }

  addSociedad() {
    let usuario = this.selected.userId;
    let valor = this.sociedad;
    this.errorSociedad = "";

    if (valor.trim() != '') {
      this.userService.agregarSociedad(valor.trim(), usuario).subscribe(
        data => {
          // console.log(data.body);
          if(data.body.mensaje == 'La SOCIEDAD ya se encuentra cargada al usuario.'){
            this.errorSociedad = data.body.mensaje;
          }
          this.getSociedadesUser();
        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout() ;
          } else {
            console.log(err);
          }
        },
      );
    }
  }

  addOrgVnts() {
    let usuario = this.selected.userId;
    let valor = this.orgVnts;
    this.errorOrgVnts = "";

    if (valor.trim() != '') {
      this.userService.agregarOrgVentas(valor.trim(), usuario).subscribe(
        data => {
          // console.log(data);
          if(data.mensaje == 'La ORGVENTAS ya se encuentra cargada al usuario.'){
            this.errorOrgVnts = data.mensaje;
          }
          this.getOrgVntsUser();
        }
        ,
        err => {
          if (err.status === 401) {
            this.storageService.openLogout() ;
          } else {
            console.log(err);
          }
        },
      );
    }
  }

  addOfVnts() {
    let usuario = this.selected.userId;
    let valor = this.ofVnts;
    this.errorOfiVnts = "";

    if (valor.trim() != '') {
      this.userService.agregarOfiVentas(valor.trim(), usuario).subscribe(
        data => {
          // console.log(data);
          if(data.body.mensaje == 'La OFICINAVEN ya se encuentra cargada al usuario.'){
            this.errorOfiVnts = data.body.mensaje;
          }
          this.getOfiVntsUser();
        }
        ,
        err => {
          if (err.status === 401) {
            this.storageService.openLogout() ;
          } else {
            console.log(err);
          }
        },
      );
    }
  }

  eliminarSociedad(value) {
    // console.log(value);

    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.eliminarLabel;
    modalRef.componentInstance.mensaje1 = this.eliminarPregunta;

    modalRef.result.then((result) => {
      // console.log(result);

      if (result === 'aceptar') {
        this.busy = true;
        let usuario = this.selected.userId;
        let valor = value;
        this.userService.eliminarSociedad(valor, usuario).subscribe(
          data => {
            // console.log(data);
            this.getSociedadesUser();
            this.busy = false;
          }
          ,
          err => {
            if (err.status === 401) {
              this.storageService.openLogout() ;
            } else {
              console.log(err);
            }
            this.busy = false;
          },
        );

      }
    });
  }

  eliminarOrgVnts(value) {
    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.eliminarLabel;
    modalRef.componentInstance.mensaje1 = this.eliminarPregunta;

    modalRef.result.then((result) => {
      // console.log(result);

      if (result === 'aceptar') {
        this.busy = true;
        let usuario = this.selected.userId;
        let valor = value;
        this.userService.eliminarOrgVentas(valor, usuario).subscribe(
          data => {
            // console.log(data);
            this.getOrgVntsUser();
            this.busy = false;
          }
          ,
          err => {
            if (err.status === 401) {
              this.storageService.openLogout() ;
            } else {
              console.log(err);
            }
            this.busy = false;
          },
        );

      }
    });
  }

  eliminarOfVnts(value) {
    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.eliminarLabel;
    modalRef.componentInstance.mensaje1 = this.eliminarPregunta;

    modalRef.result.then((result) => {
      // console.log(result);

      if (result === 'aceptar') {
        this.busy = true;
        let usuario = this.selected.userId;
        let valor = value;
        this.userService.eliminarOfiVentas(valor, usuario).subscribe(
          data => {
            // console.log(data);
            this.getOfiVntsUser();
            this.busy = false;
          }
          ,
          err => {
            if (err.status === 401) {
              this.storageService.openLogout() ;
            } else {
              console.log(err);
            }
            this.busy = false;
          },
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/users/users.component.ts